<div class="flex flex-col h-full">
  <div class="cursor-pointer pt-2 text-center" (click)="goToHome()">
    <div class="flex justify-center">
      <img src="/icons/logo-v2.png" alt="Billytics Logo" class="logo" />
    </div>
    <span class="title font-semibold">Billytics</span>
  </div>

  <div class="py-4 self-center">
    <a matButton class="large-button" href="/#home">
      <mat-icon class="no-margin">home</mat-icon>
    </a>
    <div class="text-center">
      <span> Home </span>
    </div>
  </div>

  <div class="py-4 self-center">
    <a matButton class="large-button" href="/#features">
      <mat-icon class="no-margin">widgets</mat-icon>
    </a>
    <div class="text-center">
      <span> Features </span>
    </div>
  </div>

  <div class="py-4 self-center">
    <a matButton class="large-button" href="/#pricing">
      <mat-icon class="no-margin">monetization_on</mat-icon>
    </a>
    <div class="text-center">
      <span> Pricing </span>
    </div>
  </div>

  <div class="py-4 self-center">
    <a matButton href="/#faq" class="large-button">
      <mat-icon class="no-margin">help</mat-icon>
    </a>
    <div class="text-center">
      <span> FAQ </span>
    </div>
  </div>

  <div class="py-4 self-center">
    <a matButton href="/contact-us" class="large-button">
      <mat-icon class="no-margin">contact_mail</mat-icon>
    </a>
    <div class="text-center">
      <span> Contact Us </span>
    </div>
  </div>
</div>
